import { Button, Col, Form, Input, Row } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ImageUrl } from "../../config/helper";
import swal from "sweetalert";
import { Post } from "../../config/api/post";
import { RESET } from "../../config/constants/api";

const ForgotPassword3 = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { email, code } = location?.state;
  useEffect(() => {
    if (!email || !code) {
      navigate("/enter-email");
    }
  }, []);

  const onFinish = (values) => {
    if (values.password !== values.cpassword) {
      swal("Error", "Passwords should match", "error");
      return;
    }
    Post(RESET.resetPassword, {
      email,
      code,
      password: values.password,
      type: "USER",
    })
      .then((response) => {
        if (response?.status) {
          form.resetFields();
          swal('System Alert',"Your password has been reset. Please login to continue.", 'success')
          navigate("/signIn");
        }
      })
      .catch((err) => {
        console.log("Error", err);
        swal("Error", err?.response?.data?.message, "error");
      });
  };
  return (
    <>
      {/* <Header /> */}
      <Row
        justify="center"
        style={{
          backgroundImage: `url('${ImageUrl("register-back.png")}')`, // Setting background color to black with 90% opacity
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="flex items-center justify-center min-h-screen"
      >
        <Col
          lg={8}
          md={18}
          xs={22}
          className="flex flex-col justify-center my-52 max-sm:my-32"
        >
          <div className="flex flex-col justify-center items-center bg-white rounded-lg py-8 px-8 max-lg:px-2 ">
            <h3 className="mt-4 font-tavi text-3xl text-black max-md:text-xl">
              Forgot Password
            </h3>
            <p className="capitalize font-euclid text-sm text-[#34324B] mb-8 max-md:text-xs text-center">
              Set your new password
            </p>
            <Form
              form={form}
              name="normal_login"
              onFinish={onFinish}
              layout="vertical"
              className="w-full px-8 max-xl:px-2"
            >
              <Row justify="center">
                <Col md={24} sm={24} xs={24}>
                  <Form.Item
                    name="password"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        New Password
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input password!",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Enter New Password"
                      className="h-12 text-sm font-euclid bg-gray-100 "
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Col md={24} sm={24} xs={24}>
                  <Form.Item
                    name="cpassword"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Confirm Password
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input password!",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Confirm Password"
                      className="h-12 text-sm font-euclid bg-gray-100 "
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Col md={12}>
                  <Form.Item className="self-center text-center">
                    <Button
                      htmlType="submit"
                      className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-white px-14 h-[50px] hover:text-customGold text-center text-sm"
                    >
                      {loading ? "LOADING..." : "UPDATE"}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Link
                  to="/signIn"
                  className="font-euclid text-black text-sm border-b-2 border-black font-semibold mt-8 hover:text-black"
                >
                  Back to Sign In
                </Link>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ForgotPassword3;
